import { useState } from 'react';
import SEO from '../components/SEO';
import posthog from 'posthog-js';
import { CALENDLY_LINK } from '../constants';
import { InlineWidget } from "react-calendly";
import './Contact.css';

export default function Contact() {
    const [formData, setFormData] = useState({

        naam: '',
        email: '',
        telefoon: '',
        bedrijf: '',
        onderwerp: '',
        bericht: ''
    });

    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);

        // Track event in PostHog
        posthog.capture('contact_form_submitted', {


            email: formData.email,
            telefoon: formData.telefoon,
            bedrijf: formData.bedrijf,
            onderwerp: formData.onderwerp,
            bericht: formData.bericht
        });

        setFormData({ naam: '', email: '', telefoon: '', bedrijf: '', onderwerp: '', bericht: '' });
        setSubmitted(false);
    };

    return (
        <div className="contact">
            <SEO
                title="Contact - Veloce Software"
                description="Neem contact op met Veloce Software voor een vrijblijvend gesprek. Wij helpen u graag verder met uw software vraagstukken."
            />
            <div className="page-header">
                <h1>Contact</h1>
                <p>Laat ons weten hoe we u kunnen helpen</p>
            </div>

            <div className="contact-container">
                <div className="contact-info">
                    <h2>Neem contact met ons op</h2>
                    <p>
                        Heeft u vragen of wilt u uw project met ons bespreken?
                        Vul het formulier in of neem direct contact op.
                    </p>
                    <div className="contact-details">
                        <div className="detail-item">
                            <h3>Email</h3>
                            <p><a href="mailto:info@velocesoftware.nl">info@velocesoftware.nl</a></p>
                        </div>
                    </div>

                    <div className="contact-cta">
                        <p>Liever direct een gesprek inplannen?</p>
                        <InlineWidget url={CALENDLY_LINK} styles={{ height: '700px' }} />
                    </div>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                    {submitted && (
                        <div className="success-message">
                            Bedankt! Uw bericht is verzonden. Wij nemen spoedig contact op.
                        </div>
                    )}
                    <div className="form-group">
                        <label htmlFor="naam">Naam *</label>
                        <input
                            type="text"
                            id="naam"
                            name="naam"
                            value={formData.naam}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email *</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="telefoon">Telefoonnummer</label>
                        <input
                            type="tel"
                            id="telefoon"
                            name="telefoon"
                            value={formData.telefoon}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="bedrijf">Bedrijf</label>
                        <input
                            type="text"
                            id="bedrijf"
                            name="bedrijf"
                            value={formData.bedrijf}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="onderwerp">Onderwerp *</label>
                        <input
                            type="text"
                            id="onderwerp"
                            name="onderwerp"
                            value={formData.onderwerp}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="bericht">Bericht *</label>
                        <textarea
                            id="bericht"
                            name="bericht"
                            value={formData.bericht}
                            onChange={handleChange}
                            rows="6"
                            required
                        ></textarea>
                    </div>

                    <button type="submit" className="submit-button" onClick={handleChange}>Verstuur Bericht</button>
                </form>
            </div>
        </div>
    );
}
